import { useState, useRef, useCallback, useMemo, useEffect } from 'react'

const useLongPress = ({ callback, threshold = 500 } = {}) => {
  const [action, setAction] = useState('')

  const timerRef = useRef(null)
  const isLongPress = useRef(false)

  const startPressTimer = useCallback(() => {
    isLongPress.current = false
    timerRef.current = setTimeout(() => {
      isLongPress.current = true
      setAction('long-press')
    }, threshold)
  }, [threshold])

  const handleOnClick = useCallback(() => {
    if (!isLongPress.current) {
      setAction('click')
    }
  }, [])

  const handleOnMouseDown = useCallback(() => {
    startPressTimer()
  }, [startPressTimer])

  const handleOnMouseUp = useCallback(() => {
    clearTimeout(timerRef.current)
  }, [])

  const handleOnTouchStart = useCallback(() => {
    startPressTimer()
  }, [startPressTimer])

  const handleOnTouchEnd = useCallback(() => {
    if (action !== 'long-press') {
      clearTimeout(timerRef.current)
    }
  }, [action])

  const handlers = useMemo(
    () => ({
      onClick: handleOnClick,
      onMouseDown: handleOnMouseDown,
      onMouseUp: handleOnMouseUp,
      onTouchStart: handleOnTouchStart,
      onTouchEnd: handleOnTouchEnd,
    }),
    [
      handleOnClick,
      handleOnMouseDown,
      handleOnMouseUp,
      handleOnTouchEnd,
      handleOnTouchStart,
    ],
  )

  useEffect(() => {
    if (action === 'long-press' && callback) {
      callback()
    }
  }, [action, callback])

  return {
    handlers,
  }
}

export default useLongPress
